import * as React from 'react'
import { PageContent } from '@components/pages'
import { PageContentHeader } from '@components/pages/page-content-header'
import { Paths } from '@logic'
import { EmptyState } from '@shared/components/empty-state'
import { BaseLinkProps } from '@components/navigation/navigation'

export const AgentMonitorPage: React.FC<any> = () => {
  const parent: BaseLinkProps = { path: Paths.adminRoot }

  return (
    <PageContent>
      <PageContentHeader title="Agent Monitor" parent={parent} />
      <EmptyState
        title="Agent Monitoring Contract"
        description="No session-log endpoint is mounted for this page yet. Current backend status comes from GET /api/v1/admin/gateway/health, GET /api/v1/admin/gateway/token, and GET /api/v1/prime/status."
      />
    </PageContent>
  )
}
